let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("71Xc8")).then(() => parcelRequire('lFYEk'));